import { XoneraMark } from '../common/XoneraMark';

/**
 * The "about Xonera" half of the auth split layout.
 *
 * Identical on every auth screen on purpose - it is the fixed thing you return
 * to while the task on the right changes between signing in, confirming an
 * email, and recovering an account.
 *
 * Sibling to `BrandBar`, not a variant of it. `BrandBar` is a fixed top bar for
 * pages that have a page below it; this is a column that shares a grid row with
 * the task. Auth pages render this INSTEAD of `BrandBar` - rendering both puts
 * the wordmark on screen twice, which is especially obvious below `md` where
 * the panel stacks directly under the bar.
 *
 * Deliberately transparent: the app shell's lattice reads through it, which
 * keeps the surface contract intact - the task card stays the raised thing and
 * the brand sits behind it. An earlier version put this on `bg-card` with the
 * form bare, which made the decoration the elevated element and the actual job
 * the recessed one.
 */
export function BrandPanel() {
  return (
    <div className='flex flex-col gap-5'>
      <div className='flex items-center gap-3'>
        <XoneraMark className='h-10 w-10' />
        <span className='text-xl font-bold text-foreground'>Xonera</span>
      </div>
      {/* `text-display` is kept OUT of any cn() call. cn() runs tailwind-merge,
          which does not recognise this repo's custom fontSize keys and so
          classifies them as colours - `cn('text-display text-foreground')`
          resolves to just `text-foreground` and the size silently vanishes.
          Plain concatenation only for the named type roles.

          The variable-weight second line uses Inter's 100-900 axis, which the
          product loads and interpolates nowhere else.

          Below `md` the panel stacks ABOVE the form, so every pixel of it
          pushes the form down: the headline drops to `text-title` and the
          paragraph is hidden, which is what keeps sign-in and register from
          scrolling at 390x844 (asserted in App/Auth/Mobile/Layout/AuthPage). */}
      <h2 className='max-w-[14ch] text-title text-foreground md:text-display'>
        Learn it.
        <span
          className='block text-muted-foreground'
          style={{ fontVariationSettings: "'wght' 280" }}
        >
          Then keep it.
        </span>
      </h2>
      <p className='hidden max-w-[34ch] text-body-lg text-muted-foreground md:block'>
        Lessons, notes and practice, in one place that remembers what you have
        already learned.
      </p>
    </div>
  );
}
